export const toDetailPageConfig = function (row) {
  // accessMode:1:后台审批 2:钉钉审批
  // bizType:1:收款审批；2:租赁退车付款审批；3:租赁退车收款审批；4:支付宝支付解约；5:网约钱包支付解约；6:维保方案创建审批；7:维保方案终止审批；8:维保单创建审批；9:维保方案变更审批；10:企业订单换车审批;11应收调整；12金额减免
  // bizType为2或3路由对象
  const leaseRouter = {
    path: '/workbench/rentOrder/detail',
    query: {
      id: row.bizId,
      type: 5,
      orderType: 'personal',
    },
  }
  // bizType为4或5路由对象
  const withholdRouter = {
    path: '/companyNew/approveList/detail',
    query: {
      id: row.id,
      bizId: row.bizId,
      bizType: row.bizType,
      state: row.state,
      type: 'widthhold',
    },
  }

  // bizType为6或7路由对象
  const mainTenanceRouter = {
    path: '/workbench/rentOrder/detail',
    query: {
      id: row.bizId,
    },
  }

  // 其他路由对象
  const otherRouter = {
    path: '/companyNew/approveList/detail',
    query: {
      bizType: row.bizType,
      id: row.bizId,
      type: 'approval',
      reviewId: row.id,
      approvalState: row.state,
      accessMode: row.accessMode,
    },
  }

  const approvalRouters = {
    accessMode: {
      1: {
        bizType: {
          1: {
            to: () => {
              this.$router.push(otherRouter)
            },
          },
          2: {
            to: () => {
              this.$router.push(leaseRouter)
            },
          },
          3: {
            to: () => {
              this.$router.push(leaseRouter)
            },
          },
          4: {
            to: () => {
              this.$router.push(withholdRouter)
            },
          },
          5: {
            to: () => {
              this.$router.push(withholdRouter)
            },
          },
          6: {
            to: () => {
              this.$router.push(mainTenanceRouter)
            },
          },
          7: {
            to: () => {
              this.$router.push(mainTenanceRouter)
            },
          },
          8: {
            to: () => {
              this.$router.push(otherRouter)
            },
          },
          9: {
            to: () => {
              this.$router.push(otherRouter)
            },
          },
          10: {
            to: () => {
              this.$router.push(otherRouter)
            },
          },
        },
      },
      2: {
        to: () => {
          this.$router.push({
            path: '/companyNew/approveList/detail',
            query: { accessMode: row.accessMode, id: row.id, bizId: row.bizId, bizType: row.bizType },
          })
        },
      },
    },
  }
  // 获取是后台审批还是钉钉审批
  const accessMode = approvalRouters.accessMode[row.accessMode]
  // 判断审批内容
  if (accessMode.bizType) { // 后台审批跳转
    // 不同审批内容跳转不同路哟雨
    accessMode.bizType[row.bizType].to()
  } else { // 钉钉审批跳转
    accessMode.to()
  }
}
